import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import FourFlows from './FourFlows';
import DomainSelection from './DomainSelection';
import { Mixpanel } from '../../config/Mixpanel';
import Constants from '../../common/constants';

const StepFive = ({ handleSetStep }) => {

    const secondBranch = useSelector((store) => store?.onBoarding?.secondBranch) || false;
    const wayToReach = useSelector((store) => store?.onBoarding?.wayToReach) || "";

    

  return (
    secondBranch ? <FourFlows/> : <DomainSelection handleSetStep={handleSetStep}/>
  )
}

export default StepFive